import styled from "styled-components";

export const ColorFulSpan = styled.span`
  color: ${({ theme, valid }) =>
    !valid
      ? theme.colors.feedbackState.critical.default
      : theme.colors.feedbackState.success.default};
`;
export const SafePassword = styled.ol`
  list-style-position: inside;
  display: table;
  color: ${({ $color }) => $color || "black"};
`;
